<template>
  <div :class="$style.container">
    <div :class="$style.tab">
      <div
        :class="[$style.tab_item, tabIndex === index && $style.active]"
        v-for="(item, index) in tablist"
        :key="index"
        @click="clickTab(index)"
      >
        {{ item }}
      </div>
    </div>

    <div :class="$style.content">
      <div v-show="tabIndex === 0" :class="$style.rule">
        <p :class="$style.tips">
          域名转入(Domain
          Transfer）又称域名转移注册商，即将某域名从当前的注册商A转出，转入到识道网络进行管理。
        </p>
        <h3 :class="$style.title">转入的域名需要符合以下转入规则:</h3>
        <li :class="$style.text" v-for="(item, index) in ruleList" :key="index">
          {{ item }}
        </li>
      </div>

      <div v-show="tabIndex === 1" :class="$style.flow">
        <div
          :class="$style.flow_item"
          v-for="(item, index) in flowList"
          :key="index"
        >
          <div :class="$style.flow_icon">
            <img :class="$style.icon" :src="item.icon" />
          </div>

          <p :class="$style.flow_title">{{ item.title }}</p>
          <p :class="$style.flow_text">{{ item.text }}</p>
        </div>
      </div>

      <div v-show="tabIndex === 2" :class="$style.expense">
        <p :class="$style.tips">
          <img :class="$style.notice_icon" src="@assets/image/notice.png" />
          域名转入免费，转入价格为域名一年的续费价格。域名转入识道网络的同时，该域名续费一年
        </p>
        <el-table :data="expenseList" :fit="true" stripe style="width: 100%">
          <el-table-column
            prop="suffix"
            label="域名后缀"
            width="120"
            align="center"
          />
          <el-table-column
            prop="level1"
            label="普通会员"
            width="120"
            align="center"
          />
          <el-table-column
            prop="level2"
            label="金牌会员"
            width="120"
            align="center"
          />
          <el-table-column
            prop="level3"
            label="钻石会员"
            width="120"
            align="center"
          />
          <el-table-column
            prop="level4"
            label="皇冠会员"
            width="120"
            align="center"
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabIndex: 0,
      tablist: ["转入规则", "转入流程", "转入费用"],

      ruleList: [
        "转入域名时如提示°注册商转移保护“，请联系域名现所在注册商对域名进行解锁。",
        "国际域名转入请确认距最后一次续费已满60天，否则有可能会出现转入成功续费掉年的现象。",
        "域名到期前15天不能转入。",
        "域名处于纠纷、仲裁中或法院限制转出的不能转入。",
      ],
      flowList: [
        {
          icon: require("@assets/image/flow1.png"),
          title: "01 / 填写域名、转移码",
          text: `向域名原注册商提交域名转出，获\n取转移密码。\n域名转入秘籍（新手必看）`,
        },
        {
          icon: require("@assets/image/flow2.png"),
          title: "02 / 提交购物车，进行结算",
          text: `域名转入识道网络免费\n域名转入价格即为续费一年`,
        },
        {
          icon: require("@assets/image/flow3.png"),
          title: "03 / 验证所有者邮箱\n(cn等国内域名无需此步)",
          text: `转入com等国际域名，系统发送\n确认邮件至域名所有者\n邮箱，需在15日内点击链接\n进行确认`,
        },
        {
          icon: require("@assets/image/flow4.png"),
          title: "04 / 验证转移密码,转入成功",
          text: `转移密码验证通过，域名开始转入\n识道网络。转入处理需要\n大约5-7天。5-7天后域名\n成功转入识道网络`,
        },
      ],
      expenseList: [],
    };
  },
  methods: {
    clickTab(idx) {
      this.tabIndex = idx;
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  margin-top: 50px;
  border: $border-1;

  .tab {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: $border-1;

    .tab_item {
      width: rem(470);
      height: rem(70);
      @include flex();
      font-size: max(rem(18), 16px);
      color: #333;
      user-select: none;
      background: #f7f7fa;
      border-bottom: rem(5) solid #f7f7fa;
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
      &.active {
        color: $theme-color;
        border-color: $theme-color;
      }
    }
  }

  .content {
    min-height: 200px;
    padding: rem(30) rem(50) rem(50);
    font-size: rem(14);
    color: #333;
  }

  .rule {
    .tips {
      line-height: 50px;
    }

    .title {
      font-size: max(rem(16), 14px);
      font-weight: bold;
      line-height: 60px;
    }
    .text {
      line-height: 40px;
    }
  }

  .flow {
    @include flex();

    .flow_item {
      flex: 1;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .flow_icon {
      width: rem(60);
      height: rem(60);
      margin: 30px 0 20px;
      background: #f7f7fa;
      border-radius: 50%;
      user-select: none;
      @include flex();

      .icon {
        width: rem(30);
        object-fit: cover;
      }
    }

    .flow_title {
      height: 60px;
      white-space: pre;
      text-align: center;
      font-size: max(rem(16), 14px);
      font-weight: bold;
      line-height: 24px;
    }

    .flow_text {
      white-space: pre;
      text-align: center;
      line-height: 24px;
    }
  }

  .expense {
    .tips {
      line-height: 50px;
      margin-bottom: rem(20);

      .notice_icon {
        width: 20px;
        margin-right: rem(20);
        object-fit: cover;
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
